import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { UppyAllowedFileTypes, UppyComponentEventType } from '../../asset-uploads/types';

@Component({
  selector: 'bulb-uppy-dashboard-demos',
  templateUrl: './uppy-dashboard-demos.component.html',
  styleUrls: ['./uppy-dashboard-demos.component.scss'],
  standalone: false,
})
export class UppyDashboardDemosComponent {

  allowedFileTypes: UppyAllowedFileTypes[] = [UppyAllowedFileTypes.IMAGE];

  constructor(private messageService: MessageService) { }

  /**
   * Opens a toast on success events.
   * @param event to get the type from.
   */
  public handleSuccessEvent(event: any) {
    if (event.type === UppyComponentEventType.ON_SUCCESS) {
      this.messageService.add({
        key: 'uppyUploadToast',
        severity: 'success',
        summary: 'Uppy Dashboard Upload',
        detail: 'Upload Success',
      });
    }
  }
}
